let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("35AkR")).then(() => parcelRequire('6lOgx'));